export default __webpack_public_path__ + "static/media/evenShotBg.06de504a.png";